import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {appContext} from '../../../../app.context';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoCertificazioneUnicaStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {

    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.documentTypes = ['Fattura', 'Parcella', 'Nota di Credito', 'Nota di Debito', 'Acconto/Anticipo'];

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {
      anno: number,
      scadenza: string
    }[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.contribuente = {};
    $scope.PivaType = new RegExp('(^[0-9]{11}$)|ND');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{16}$');
    let isContribuenteCodiceFiscaleDisabled;
    let isContribuentePivaDisabled;

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    $scope.saveAnagrafica = () => {
      let anagrafica = [];
      if ($scope.anagraficaContribuenteIsNew) {
        anagrafica.push({
          'email_pec': '',
          'emails': [],
          'company_name': $scope.contribuente.anagrafica.full_name,
          //'company_name': $scope.settings.contribuenteRagioneSociale,
          'fiscal_code': $scope.settings.contribuenteCodiceFiscale,
          'piva': $scope.settings.contribuentePiva
        });
      }

      ArchiSmallServices.insertAnagrafica(anagrafica)
        .then((response: any) => {
          // ??
        }, (error) => {
          if (error.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', 'Anagrafica già esistente');
          }
        });
    };

    $rootScope.formsubmitted = false;

    // <editor-fold desc='setConservazioneSettings'>
    $scope.setConservazioneSettings = () => {
      //$scope.settings.contribuenteRagioneSociale = $scope.contribuente.anagrafica;
      let classeDocumentale = $scope.settings.classeDocumentale.key;

      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

            if ($scope.settings.contribuenteRagioneSociale !== undefined) {
              $scope.contribuente.anagrafica = $scope.settings.contribuenteRagioneSociale;
              isContribuenteCodiceFiscaleDisabled = $scope.settings.contribuenteCodiceFiscale !== '' && $scope.settings.contribuenteCodiceFiscale !== undefined;
              isContribuentePivaDisabled = $scope.settings.contribuentePiva !== '' && $scope.settings.contribuentePiva !== undefined;
            }
          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    $scope.removeContribuente = () => {
      delete $scope.settings.contribuenteCodiceFiscale;
      delete $scope.settings.contribuentePiva;
      delete $scope.settings.contribuenteRagioneSociale;
    };

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.dpOpened = {
      dataDocumento: false,
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:disable:no-string-literal */
    $scope.autoOpen = ($event, opened) => {
      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item) => {
      if (item !== undefined && typeof item === 'object') {
        $scope.settings.contribuentePiva = item.piva;
        $scope.settings.contribuenteCodiceFiscale = item.fiscal_code;
        $scope.anagraficaContribuenteIsNew = item.piva == null;
        isContribuenteCodiceFiscaleDisabled =
          item.fiscal_code !== '' && item.fiscal_code !== undefined;
        isContribuentePivaDisabled =
          item.piva !== '' && item.piva !== undefined;
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);

      $scope.contribuente.anagrafica = '';
      $scope.settings.contribuenteRagioneSociale = '';
      $scope.settings.contribuentePiva = '';
      $scope.settings.contribuenteCodiceFiscale = '';
      isContribuenteCodiceFiscaleDisabled = false;
      isContribuentePivaDisabled = false;
      $scope.anagraficaIsNew = false;
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.isContribuenteCodiceFiscaleDisabled = () => {
      return isContribuenteCodiceFiscaleDisabled;
    };

    $scope.isContribuentePivaDisabled = () => {
      return isContribuentePivaDisabled;
    };

    // <editor-fold desc='openCertificazioneUnicaWorkerModal'>
    $scope.openCertificazioneUnicaWorkerModal = (size) => {

      if ($scope.anagraficaIsNew) {
        $scope.saveAnagrafica();
      }
      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');
      if ($scope.contribuente.anagrafica) {
        $scope.settings.contribuenteRagioneSociale = $scope.contribuente.anagrafica.full_name;
      } // else {
      // $scope.settings.contribuenteRagioneSociale = "";
      //}

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerCertificazioneUnicaModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };
    // </editor-fold>

  }
}

export const ConservazioneCaricaDocumentoCertificazioneUnicaStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-certificazione-unica-step2.html'),
  controller: ConservazioneCaricaDocumentoCertificazioneUnicaStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-certificazione-unica-step2/conservazione-carica-documento-certificazione-unica-step2.ts